import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  heading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.5rem'
  },
  emptyState: {
    textAlign: 'left',
    padding: theme.spacing(4, 2)
  },
  emptyStateList: {
    marginBottom: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    textAlign: 'left'
  },
  emptyStateListItem: {
    marginBottom: theme.spacing(1)
  },
  emptyStateButtonGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3)
  }
}))
